import { IAutoCompleteItem } from '../../../models/autoComplete';
import { CONSTANTS } from '../../../utils/constants';
import { IDynamicList } from '../../../store/entities/general/type';

export const getPickupIssueReasonItems = (
  reasons: IDynamicList[],
  appLanguage: string
): IAutoCompleteItem[] => {
  return reasons.map((reason: IDynamicList) => ({
    id: reason.id,
    label:
      (appLanguage === CONSTANTS.DEFAULT_LANGUAGE
        ? reason.nameHE
        : reason.nameEN) ?? '',
  }));
};

export const getPickupIssueReasonLabel = (
  reasons: IDynamicList[],
  reasonId: number | null | undefined,
  appLanguage: string
): string | undefined => {
  if (!reasonId) {
    return undefined;
  }

  const reason = reasons.find((item: IDynamicList) => item.id === reasonId);

  if (!reason) {
    return undefined;
  }

  return (
    (appLanguage === CONSTANTS.DEFAULT_LANGUAGE
      ? reason.nameHE
      : reason.nameEN) ?? ''
  );
};
